<ng-container *ngIf="vm$ | async; let vm">
  <form [formGroup]="form" class="relative">
    <dot-background-overlay
      [customClasses]="['br3']"
      [bgHexColor]="content?.bgColor"
      [opacity]="content?.opacity | jbStringToNumber"
    >
    </dot-background-overlay>

    <div class="relative pa3 flex flex-column">
      <!--trip type-->
      <div class="flex justify-between pa0 mb2 w-100">
        <div class="flex dropdown-container">
          <ng-container
            *ngTemplateOutlet="tripTypeSelector; context: { form: form }"
          ></ng-container>
          <dot-traveler-selector
            #travelerSelector
            formControlName="travelers"
            [content]="content.travelSelector"
            [bookerType]="bookerType.air"
            [bookerId]="bookerId"
            [placement]="'bottom-start'"
            [showValidationErrors]="showFormErrors"
            [infantsCountTowardsTotalTravelers]="
              isInternationalRoute || isInterlineRoute
            "
            [defaultToOneTravellerIfZeroSet]="true"
            data-qaid="travelerSelector"
          ></dot-traveler-selector>
        </div>
        <!-- tb points checkbox -->
        <div class="ml-auto dib-ns dn" *ngIf="!isMultiCity">
          <jb-checkbox
            class="white mb2 justify-center order-1-ns"
            formControlName="bookWithPoints"
            name="bookWithPoints"
          >
            <span class="charcoal">{{ trueblueLabel }}</span>
          </jb-checkbox>
        </div>
      </div>

      <!-- start of multi-city forms -->
      <dot-booker-air-multi-city
        class="w-100"
        *ngIf="isMultiCity"
        [content]="content"
        [regions]="regions"
        [recentAirports]="recentAirports"
        [separatePartnerCities]="separatePartnerCities"
        [showValidationErrors]="showValidationErrors"
        [isInternationalInterline]="isInternationalRoute || isInterlineRoute"
      ></dot-booker-air-multi-city>
      <!-- multi-city submit button -->
      <ng-content select="[multi-city]"></ng-content>
      <!-- end of multi-city forms -->

      <!-- -------------start of non-multi-city input forms------------ -->
      <ng-container *ngIf="!isMultiCity">
        <div
          class="grid-container"
          [ngClass]="{
            'with-promo-code': hasPromoCode,
            'one-way': !isRoundTrip
          }"
        >
          <!-- city pair selector -->
          <ng-container formArrayName="flights">
            <ng-container
              *ngFor="
                let flight of (form | jbGetFormControl: 'flights').controls;
                let i = index
              "
            >
              <!-- city pair selector -->
              <dot-city-pair-selector
                [formControl]="flight"
                [content]="content.citySelector"
                [showShortCityName]="showShortCityName"
                [recentAirports]="recentAirports ? recentAirports[i] : {}"
                [formWrapper]="nativeElem"
                [separatePartnerCities]="separatePartnerCities"
                [isMobile]="isMobile"
                [origins]="origins"
                [origin]="origin"
                [destination]="destination"
                [destinations]="destinations"
                [showValidationErrors]="showValidationErrors || showFormErrors"
                (originChange)="onOriginChange.emit($event)"
                (destinationChange)="onDestinationChange.emit($event)"
                class="grid-city-selector"
                data-qaid="cityPairSelector"
                [swappable]="true"
              >
              </dot-city-pair-selector>
            </ng-container>
          </ng-container>

          <!-- date-range-picker -->
          <div class="grid-date-picker">
            <dot-date-range-picker
              [content]="content.dateAggregator"
              [startDate]="departDate"
              [endDate]="returnDate"
              [totalCost]="totalCost$ | async"
              [isOneWay]="
                (form | jbGetFormControl: 'tripType').value ===
                tripTypeEnum.ONEWAY
              "
              [departureControl]="form | jbGetFormControl: 'departureDate'"
              [returnControl]="form | jbGetFormControl: 'returnDate'"
              [showValidationErrors]="!!departureDateError || !!returnDateError"
              [departErrorMessage]="departureDateError"
              [returnErrorMessage]="returnDateError"
              [minDate]="todayDate"
              [isMobile]="isMobile"
              class="t-fast"
              [seasonalRouteMessage]="
                vm.bffIntegrationEnabled
                  ? vm.calendarMessage
                  : isSeasonalRoute
                  ? content.bookMessages.seasonalRouteMessage
                  : ''
              "
              [placement]="'bottom-end'"
              [showSchedule]="vm.bffIntegrationEnabled"
              [keepCalendarOpen]="keepCalendarOpen"
              [showPricing]="vm.pricingEnabled"
              (monthVisibilityChange)="handleVisibilityChange($event)"
              (onStartDateChange)="onStartDateChange($event)"
              (onEndDateChange)="onEndDateChange($event)"
              (flyoutStateChange)="onFlyoutStateChange($event)"
              (startDateFocused)="handleStartDateFocused()"
              (endDateFocused)="handleEndDateFocused()"
              [showTripTypeMobile]="true"
            >
              <div *ngIf="tripType?.value !== tripTypeEnum.MULTICITY">
                <jb-select
                  type="simple"
                  formControlName="tripType"
                  data-qaid="tripType"
                >
                  <ng-container *ngFor="let tripType of tripTypes">
                    <jb-select-option
                      *ngIf="tripType.value !== tripTypeEnum.MULTICITY"
                      [name]="tripType.name"
                      [value]="tripType.value"
                      [attr.data-qaid]="tripType.value"
                    >
                    </jb-select-option>
                  </ng-container>
                </jb-select>
              </div>
            </dot-date-range-picker>
          </div>
          <!-- promo code -->
          <div *ngIf="hasPromoCode" class="grid-promo-code">
            <jb-promo-code-v2
              ngDefaultControl
              [formControl]="form | jbGetFormControl: 'promoCode'"
              [promoCode]="promoCodeWithSource.promoCode"
              [promoCodeData]="promoCodeData"
              (promoCodeChange)="onPromoCodeChange()"
              class="t-fast"
            ></jb-promo-code-v2>
          </div>
          <!-- tb points checkbox -->
          <div class="center mt2 db dn-ns grid-tb-points" *ngIf="!isMultiCity">
            <jb-checkbox
              class="white mb2-ns mt2 tc"
              name="bookWithPoints"
              formControlName="bookWithPoints"
            >
              <span class="legal charcoal">{{ trueblueLabel }}</span>
            </jb-checkbox>
          </div>
          <!-- submit button -->
          <div class="grid-submit-button">
            <ng-content select="[non-multi-city]"></ng-content>
          </div>
        </div>
      </ng-container>
      <!-- -------------end of non-multi-city input forms ------------ -->
      <div *ngIf="vm.vacationsLinkEnabled" class="mt2 tc tr-ns">
        {{ vm.content?.vacationsLink?.descriptionText }}
        <a
          jbInlineLink
          target="_blank"
          [href]="vm.vacationsLink"
          class="nowrap"
          >{{ vm.content.vacationsLink.linkLabel }}</a
        >
      </div>
    </div>

    <div
      *ngIf="showCaptcha"
      [class.invalid-control-div]="isCaptchInvalid()"
      class="flex justify-center center db relative"
    >
      <div
        #captchaRef
        class="pb3 br3"
        [tabindex]="isCaptchInvalid() ? 0 : -1"
        [class.invalid-control]="isCaptchInvalid()"
      >
        <div class="captcha-container">
          <re-captcha (resolved)="resolved($event)"></re-captcha>
        </div>
        <div
          *ngIf="isCaptchInvalid()"
          class="dn s-body ml3 pt2 captcha-err-msg"
        >
          {{
            ((form | jbGetFormControl: 'recaptchaReactive').errors | values)[0]
          }}
        </div>
      </div>
    </div>
  </form>
</ng-container>

<ng-template #tripTypeSelector [formGroup]="form">
  <jb-select type="simple" formControlName="tripType" data-qaid="tripType">
    <ng-container *ngFor="let tripType of tripTypes">
      <jb-select-option
        [name]="tripType.name"
        [value]="tripType.value"
        [attr.data-qaid]="tripType.value"
      >
      </jb-select-option>
    </ng-container>
  </jb-select>
</ng-template>
